var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"FoobarSettings"},[_vm._v("\n    FoobarSettings\n    ")])}
var staticRenderFns = []

export { render, staticRenderFns }